export default [
    {
        path: '/registration/field-settings',
        name: 'registration-field-settings',
        component: () => import('../../pages/registration/FieldSettingsPage.vue'),
        meta: {
            title: 'Registration Field Settings',
            requiresAuth: true,
        },
    },
]
